import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import { useMenuStyles } from "../../components/menuStyles";
// mesmo editor markdown da persona do agente — reuso direto, sem reinventar um
// segundo editor com regras próprias de formatação
import PersonaEditor from "../Agents/PersonaEditor";

const MODELO = [
  "## O que faz",
  "",
  "## Gatilho",
  "",
  "## Passos",
  "",
  "## Atenção",
  "> ",
].join("\n");

// "Readme" do fluxo. Abre em VISUALIZAR: quem clica quase sempre quer LER o que
// o fluxo faz; editar é a exceção. Sem nota nenhuma, abre direto em edição com
// um esqueleto — página em branco trava mais do que ajuda.
const FlowNotesModal = ({ open, value, onClose, onSave, readOnly }) => {
  const menu = useMenuStyles();
  const [texto, setTexto] = useState(value || "");
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (open) setTexto(value || "");
  }, [open, value]);

  const vazio = !String(value || "").trim();

  const salvar = async () => {
    setSalvando(true);
    try {
      await onSave(texto);
      onClose();
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={salvando ? undefined : onClose} maxWidth="sm" fullWidth PaperProps={{ className: menu.dialogPaper }}>
      <DialogTitle>Notas do fluxo</DialogTitle>
      <DialogContent dividers>
        <PersonaEditor
          value={texto}
          onChange={readOnly ? () => {} : setTexto}
          label="Como este fluxo funciona"
          defaultMode={vazio && !readOnly ? "edit" : "view"}
          placeholder="Descreva o que este fluxo faz — o gatilho, os passos principais e os pontos de atenção. Use ## para títulos, - para listas e > para destaques."
          emptyText="Nada escrito ainda. Volte para Editar e descreva o fluxo."
          hintEdit="Texto livre com markdown (## título, - lista, **negrito**, > destaque)."
          hintView="Prévia formatada das notas do fluxo."
          hintWriting="A IA está escrevendo as notas… você poderá editar quando ela terminar."
        />
      </DialogContent>
      <DialogActions>
        {!readOnly && vazio && !texto && (
          <Button onClick={() => setTexto(MODELO)} style={{ marginRight: "auto" }}>
            Usar modelo
          </Button>
        )}
        <Button onClick={onClose} disabled={salvando}>{readOnly ? "Fechar" : "Cancelar"}</Button>
        {!readOnly && (
          <Button onClick={salvar} color="primary" variant="contained" disabled={salvando}>
            {salvando ? "Salvando…" : "Salvar notas"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FlowNotesModal;
